import { useState } from "react";
import { useModal } from "../contexts";
import { postData } from "../backend";
import useUser from "../hooks/useUser";
import SmallTextInputField from "./SmallTextInputField";
import Modal from "./Modal";
import ErrorModal from "./ErrorModal";
import { useTranslation } from "react-i18next";


function SettingsSolutionPartnerNewTeamModal(props: { initialEmail?: string }) {
  const { closeModal, openModal } = useModal();
  const { t } = useTranslation();


  const { refreshUser } = useUser();

  const [teamName, setTeamName] = useState("");
  const [isCreating, setIsCreating] = useState(false);

  function createTeam() {
    setIsCreating(true);

    postData("/auth/team/", { name: teamName })
      .then((team) => {
        refreshUser((user: any) => ({ ...user, team }));
      })
      .catch(error => openModal(<ErrorModal details={error} />))
      .finally(() => { setIsCreating(false); closeModal() });
  }

  return (
    <Modal
      title={
        <p className="font-gilroy font-semibold text-lg">
          {t("Create a new team")}
        </p>
      }
      subtitle={t("Create a new team for your clients")}
      secondaryButtonProps={{
        text: t("Cancel"), onClick: () => closeModal()
      }}
      primaryButtonProps={{
        onClick: createTeam,
        disabled: teamName.length === 0,
        text: <>
          {isCreating ? t("Creating...") : t("Create")}
        </>
      }}
      size="sm"
    >
      <SmallTextInputField className="w-full" value={teamName} onChange={setTeamName} label={t("Team Name")} autoFocus />
    </Modal>
  );
}

export default SettingsSolutionPartnerNewTeamModal;
